import Vue from 'vue';
import socket from "client/socket";
import config from "client/config";

const filter = require("lodash/filter");

export default function (store) {
  let state = {
    items: [],
    contents: {},
    links: [],
    context: null,
    displayId: null,
  };

  const actions = {
    "displays.loadLinks": function(ctx, opts) {
      return new Promise((resolve, reject) => {
        Vue.http.get(config.root + '/events/' + opts.eventId + '/display-links').then(result => {
          store.commit('displays.setLinks', result.data)
          resolve(result.data)
        }, err => reject(err))
      })
    },
    "displays.load": function(ctx, opts) {
      if (! opts.eventId) {
        return null;
      }

      leaveRooms();
      store.commit('displays.setContext', { type: 'event', id: opts.eventId })

      return new Promise((resolve, reject) => {
        Vue.http.get(config.root + '/events/' + opts.eventId + '/displays').then(result => {
          store.commit('displays.setItems', result.data);
          joinRooms()

          store.dispatch('displayTimers.load', {eventId: opts.eventId}).then(() => resolve(result), reject);
        }, err => reject(err));
      });
    },
    "displays.loadById": function(ctx, opts) {
      if (! opts.displayId) {
        return null;
      }

      leaveRooms();
      store.commit('displays.setContext', { type: 'display', id: opts.displayId })

      return new Promise((resolve, reject) => {
        Vue.http.get(config.root + '/displays/' + opts.displayId).then(function (result) {
          store.commit('displays.setItems', [result.data]);
          joinRooms()

          Promise.all([
            store.dispatch('displays.loadContent', opts),
            store.dispatch('displayTimers.load', {eventId: result.data.eventId}),
          ]).then(() => resolve(result), reject);
        }, err => reject(err));
      });
    },
    "displays.loadContent": function(ctx, opts) {
      return Vue.http.get(config.root + '/displays/' + opts.displayId + '/content').then(result => {
        store.commit('displayContent.update', result.data);
      });
    },
    "display.update": function(ctx, display) {
      return new Promise((resolve, reject) => {
        display.resetDisplay = true
        Vue.http.patch(config.root + '/displays/' + display.id, display).then(result => {
          store.commit("display.update", result.data);
          resolve(result.data);
        }, err => reject(err));
      });
    },
    "display.add": function(ctx, opts) {
      return new Promise((resolve, reject) => {
        if (ctx.state.context.type !== 'event') {
          reject('no event context')
          return
        }

        Vue.http.post(config.root + '/events/' + ctx.state.context.id + '/displays', opts.display).then(result => {
          resolve(result.data)
        }, err => reject(err))
      });
    },
    "display.remove": function(ctx, opts) {
      return new Promise((resolve, reject) => {
        Vue.http.delete(config.root + '/displays/' + opts.displayId).then(result => {
          store.commit("display.remove", opts.displayId);
          resolve(result);
        }, err => reject(err));
      });
    },

  };

  function leaveRooms() {
    if (state.context?.id) {
      socket.emit('leave', 'display:' + state.context.id);
      socket.emit('leave', 'displayContent:' + state.context.id);
    }
    if (state.eventId) {
      socket.emit('leave', 'display:' + state.eventId);
      store.commit("displays.setEventId", undefined);
    }
    if (state.displayId) {
      socket.emit('leave', 'display:' + state.displayId);
      store.commit("displays.setDisplayId", undefined);
    }
  }

  function joinRooms() {
    if (state.context?.id) {
      socket.emit('join', 'display:' + state.context.id)
      if (state.context.type === 'display') socket.emit('join', 'displayContent:' + state.context.id)
    }
  }

  const mutations = {
    "displayContent.update": function(state, content) {
      Vue.set(state.contents, content.displayId, content);
    },
    "displays.setLinks": function(state, links) {
      Vue.set(state, 'links', links)
    },
    "displays.setItems": function(state, items) {
      Vue.set(state, 'items', items)
    },
    "displays.setContext": function(state, context) {
      Vue.set(state, 'context', context)
    },
    "display.remove": function(state, id) {
      state.items = filter(state.items, function(item) {
        return item.id !== id;
      });
    },
    "display.add": function(state, display) {
      state.items.push(display);
    },
    "display.update": function(state, display) {
      const index = state.items.findIndex(i => i.id === display.id);
      let displays = state.items;
      if (index >= 0) {
        displays.splice(index, 1, display);
      }
      else {
        displays.push(display);
      }

      Vue.set(state, 'items', displays);
    }
  };

  function listener() {
    socket.on('connect', function () {
      joinRooms()
      if (state.context?.type === 'display') {
        store.dispatch('displays.loadContent', {displayId: state.context.id});
      }
    })
    socket.on('displayContent.update', result => store.commit('displayContent.update', result.data));
    socket.on('display.update', function(result) {
      if (result.type === 'update') {
        store.commit('display.update', result.data);
        return;
      }
      if (result.type === 'create') {
        store.commit('display.add', result.data);
        return;
      }
    });
    socket.on('display.delete', result => {
      store.commit('display.remove', result.data);
    });
    socket.emit('join', 'display.delete');
  }

  store.registerModule('displays', {
    state: state,
    mutations: mutations,
    actions: actions,
  });

  listener();
}
